// extracted by mini-css-extract-plugin
module.exports = {"colorLabel":"ColorLabel_colorLabel__2R51X","defaultSize":"ColorLabel_defaultSize__3ztYf","defaultColor":"ColorLabel_defaultColor__2X4tl"};